module.exports = __webpack_public_path__ + "img/insurer-head-banner-badge-desktop.e066c23.png";